import { HeaderStyled } from "./style"

export const Header = () => {
    return (        
        <HeaderStyled>
            <h1>Nu Finance</h1>
            <button>Inicio</button>
        </HeaderStyled>
    )
}